import { render, staticRenderFns } from "./transfer-payment.vue?vue&type=template&id=8dd0e964&"
import script from "./transfer-payment.vue?vue&type=script&lang=js&"
export * from "./transfer-payment.vue?vue&type=script&lang=js&"
import style0 from "./transfer-payment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports